import React, { useState } from 'react';
import { testimonials } from '../data/mockData';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedTestimonials = showAll ? testimonials : testimonials.slice(0, 3);

  return (
    <section className="py-16 sm:py-24 px-3 sm:px-4 bg-white overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <p className="text-[#25D366] font-medium mb-3 sm:mb-4 uppercase tracking-wide text-xs sm:text-sm">Testimonials</p>
          <h2 className="text-xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            High-growth teams rely on waatee
          </h2>
          <h3 className="text-xl sm:text-3xl md:text-5xl font-bold text-gray-900">
            to build <span className="italic">lasting relationships</span>
          </h3>
        </div>

        {/* Testimonials Carousel */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-8">
          {displayedTestimonials.map((testimonial, index) => {
            const colors = [
              'bg-gradient-to-br from-blue-50 to-indigo-50',
              'bg-gradient-to-br from-pink-50 to-rose-50',
              'bg-gradient-to-br from-yellow-50 to-amber-50',
              'bg-gradient-to-br from-green-50 to-emerald-50',
              'bg-gradient-to-br from-purple-50 to-violet-50',
              'bg-gradient-to-br from-cyan-50 to-teal-50',
            ];
            return (
              <div
                key={testimonial.id}
                className={`${colors[index % colors.length]} rounded-xl sm:rounded-2xl p-3 sm:p-6 hover:shadow-lg transition-all group`}
              >
                <div className="bg-white rounded-lg sm:rounded-xl p-4 sm:p-6 h-full flex flex-col shadow-sm">
                  <Quote className="w-6 sm:w-8 h-6 sm:h-8 text-gray-200 mb-3 sm:mb-4" />
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed mb-4 sm:mb-6 flex-1">
                    "{testimonial.quote}"
                  </p>
                  <div className="flex items-center gap-2 sm:gap-3 pt-3 sm:pt-4 border-t border-gray-100">
                    <img
                      src={testimonial.avatar}
                      alt={testimonial.author}
                      className="w-8 sm:w-10 h-8 sm:h-10 rounded-full object-cover"
                    />
                    <div className="min-w-0">
                      <p className="font-semibold text-gray-900 text-xs sm:text-sm truncate">{testimonial.author}</p>
                      <p className="text-gray-500 text-[10px] sm:text-xs truncate">{testimonial.company}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Show More Button */}
        <div className="text-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-1.5 sm:gap-2 text-gray-700 font-medium hover:text-gray-900 transition-colors border border-gray-200 px-4 sm:px-6 py-2 sm:py-2.5 rounded-full hover:border-gray-300 text-sm sm:text-base"
          >
            {showAll ? 'Show less' : 'Show more'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
